module.exports = "/_next/static/images/mobile-screen-60a0efcbf68c201338a1c34f59d89d9a.jpg";